"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import styles from "./ZestLifeDefinition.module.css"
import blackLogo from "./blackzestlife.png"
import Image from "next/image"
export default function ZestLifeDefinition() {
  return (
    <section className={styles.signupSection}>
      <div className={styles.signupContent}>
        <div className={"w-full flex justify-center items-center pb-[50px]"}>
          <Image
            src={blackLogo}
            alt="ZestLife"
            className={styles.blackLogo}
            width={291}
            height={54}
          />
        </div>
        <div className={"w-full flex flex-col items-center justify-center"}>
          <div className={"w-full max-w-[787px]"}>
            <div className="pb-4  text-left ">
              <span className={"font-bold mr-2 "}>Zest:</span>
              <span>
                Little pieces of an outer layer that add enjoyment, energy, interest,
                enthusiasm, or flavor.
              </span>
            </div>
            <div className="pb-4  text-left ">
              <span className={"font-bold mr-2"}>Life:</span>
              <span>
                A series of stages and phases requiring something different, and
                often new.
              </span>
            </div>
            <div className="pb-4  text-left ">
              <span className={"font-bold mr-2"}>Mental Health:</span>
              <span>
                a lifelong relationship between one’s outer and inner world, made up
                of micro building blocks (aka: zest) and experiences that culminate
                and flux over time.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
